<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <div class="row">
          <div class="col-8">
            <h3 class="mt-1">{{ user.name }}</h3>

            <b-badge
              variant="warning"
              v-for="item in user.roles"
              :key="item.id"
              class="mr-1 mb-1"
              >{{ item.role }}</b-badge
            >

            <div v-if="userHasPerms(['Manage users'])" class="mt-2">
              <router-link
                v-b-tooltip.hover
                title="Edit"
                :to="{ name: 'users-edit', params: { id: user.id } }"
                class="text-primary table-action-icon ml-0"
              >
                <i class="lni lni-pencil"></i>
              </router-link>

              <span
                v-b-tooltip.hover
                title="Delete"
                @click="confirmDelete(user.id)"
                class="text-danger table-action-icon"
              >
                <i class="lni lni-trash"></i>
              </span>
            </div>
          </div>
          <div class="col-4">
            <v-lazy-image
              v-if="user.image"
              :src="user.image"
              class="img-fluid maxHeight200 mb-2"
            />
          </div>
        </div>
        <table class="table table-sm mt-2">
          <table-row label="Email">{{ user.email }} </table-row>

          <table-row label="Clocking ID"
            >{{ user.clocking_system_id }}
          </table-row>

          <table-row label="Branch">
            <span v-if="user.branch">{{ user.branch.name }} </span>
          </table-row>

          <table-row icon="lni-database" :noBorder="true" />

          <table-row label="Id">{{ user.id }} </table-row>

          <table-row label="Created"
            >{{
              moment(new Date(user.created_at)).format("DD MMM YYYY, HH:mm:ss")
            }}
          </table-row>
          <table-row label="Updated"
            >{{
              moment(new Date(user.updated_at)).format("DD MMM YYYY, HH:mm:ss")
            }}
          </table-row>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import userRepo from "@/api/repos/userRepo";
import tableRow from "@/components/common/TableRow";

export default {
  props: ["id"],

  components: {
    tableRow,
  },

  mounted() {
    this.getUser();
  },

  data() {
    return {
      loading: false,
      user: {
        branch: {},
      },
    };
  },

  methods: {
    async getUser() {
      try {
        this.loading = true;
        let { data } = await userRepo.get(this.id);
        this.user = data.user;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
 
  async deleteUser(id) {
    this.isBusy = true;
    try {
      await userRepo.delete(id);
      this.$emit("userUpdated");
    } catch (error) {
      console.log(error);
    } finally {
      this.isBusy = false;
    }
  },

  confirmDelete(id) {
    this.$bvModal
      .msgBoxConfirm("Please confirm that you want to delete the user.", {
        title: "Please Confirm",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: "YES",
        cancelTitle: "NO",
        footerClass: "p-2",
        hideHeaderClose: false,
        centered: true,
      })
      .then((confirm) => (confirm ? this.deleteUser(id) : false))
      .catch((error) => console.log(error));
    }

  }
    
};
</script>
